import { styled } from '@mui/material';

import { UiButton, UiIconLayout } from '@ui/atoms-button';
import { ChkIconPencil, theme } from '@ui/checkout-components';
import { useBreakpoints } from '@utility/checkout-utils';

import type { ChangeButtonProps } from './ChangeButton.types';

export const ChangeButton = ({
  disabled,
  changeLabel,
  onChangeClick,
  changeButtonTestId,
  changeButtonAriaLabel,
}: ChangeButtonProps) => {
  const { isMoreThan2xs } = useBreakpoints(theme);
  const isChangeButtonVisible = !disabled && Boolean(onChangeClick);

  if (!isChangeButtonVisible) {
    return null;
  }

  const buttonLabel = isMoreThan2xs ? changeLabel : '';
  const ariaLabel = changeButtonAriaLabel || changeLabel;

  return (
    <StyledUiButton
      data-testid={changeButtonTestId}
      variant="inline-link"
      onClick={onChangeClick}
      aria-label={ariaLabel}
      aria-disabled={disabled}
    >
      <UiIconLayout startIcon={<ChkIconPencil />} aria-hidden>
        {buttonLabel}
      </UiIconLayout>
    </StyledUiButton>
  );
};

const StyledUiButton = styled(UiButton)(({ theme }) => ({
  ...theme.typography.body2,
  fontWeight: theme.typography.fontWeightMedium,
  padding: 0,

  '& span:first-of-type': {
    marginRight: theme.spacing(0),
  },

  '& svg': {
    width: theme.spacing(7),
    height: theme.spacing(7),
    marginRight: theme.spacing(0),

    [theme.breakpoints.up('2xs')]: {
      marginRight: theme.spacing(2),
    },
  },
}));
